/* eslint-disable security/detect-unsafe-regex */
export const urlRegex =
	/^((https?):\/\/)?((?:www\.)?(?!(?:www))[a-z0-9-]*){1}(\.[a-z]{2,}){1,3}\b(?:[#\/]{1}.*)?$/; //NOSONAR
